'use strict';
import angular from 'angular';
import $ from 'jquery';
import _ from "lodash";
import moment from "moment";
import layoutHtmlUrl from './layout.html';
import {$WidgetBuilderEvents} from "coreModules/design/widget/builder/widget.builder.constants";
import EventBus from "../../../../../../grok/src/modules/core/app/helpers/EventBus";
import {AiSummariesRoute} from "../../../../../../grok/src/modules/ta/chatgptsummaries/chatgptsummaries.constants";
import { Module } from "../../../../../../grok/src/modules/core/app/constants/app.constants";
import Permission from '../../../../permission';
import {
  AI_ASSISTANT_CLICK_EVENT,
  AI_CONFIGS_READY_EVENT,
} from '../../../../../../grok/src/modules/core/nav/nav.constants';

angular.module('design.layout.directives', [])

    .component('designLayout', {
        templateUrl: layoutHtmlUrl,
        bindings: false,
        controllerAs: 'vm',
        replace: true,
        controller: LayoutController
    })
    .directive('resetDelayedAnimation', resetDelayedAnimation);

/**
 * @ngInject
 */
function LayoutController(
    PubSub,
    gettextCatalog,
    $LayoutEvents,
    DesignFactory,
    LayoutFactory,
    EditLayoutFactory,
    SlidePanelFactory,
    DashboardFilterPanelFactory,
    ExportBuilderDashboardService,
    WidgetResizeService,
    WidgetType,
    MomentDateFormat,
    PageEntity,
    WidgetGoalModelFactory,
    DateRangeFactory,
    RelativeDateRange,
    AppFactory,
    UIFactory
) {
    var vm = this;

    vm.$onInit = $onInit;
    vm.$postLink = $postLink;
    vm.$onDestroy = $onDestroy;
    vm.layoutIsPacked = layoutIsPacked;
    vm.layoutIsPredefined = layoutIsPredefined;
    vm.toggleResizeGrid = toggleResizeGrid;
    vm.triggerResize = triggerResize;
    vm.getWidgetClass = getWidgetClass;
    vm.canResizeWidgets = () => !_.includes([PageEntity.PAGE_OVERVIEW, PageEntity.PAGE_CATEGORIES_OVERVIEW], DesignFactory.getCurrentPage().entity);

    vm.resizingWidget = null;

    function $onInit() {
        _registerEvents();
        vm.layout = LayoutFactory;
        vm.editLayout = EditLayoutFactory.shared;
        vm.exportBuilder = ExportBuilderDashboardService.getBuilder();
        vm.isPredefined = DesignFactory.getCurrentLayout().is_predefined;
        // Run this once widgets have been loaded inside layout
        LayoutFactory.updateLayoutWidgets();
        WidgetResizeService.onWidgetResize(_onWidgetResize);
    }

    function $postLink() {

    }

    function $onDestroy() {
        _unregisterEvents();
        SlidePanelFactory.closeAll();
        DashboardFilterPanelFactory.resetWidgetFilterOptionList();
        WidgetResizeService.offWidgetResize(_onWidgetResize);
    }

    function layoutIsPacked() {
        return DesignFactory.getCurrentLayout().metadata.is_packed;
    }

    function layoutIsPredefined() {
        return DesignFactory.getCurrentLayout().is_predefined;
    }

    function triggerResize(widget) {
        vm.resizingWidget = widget;
    }

    function getWidgetClass(widget) {
        var isotopeClassList = [widget.type + '-type-widget', (widget.metadata.data_source ? widget.metadata.data_source.type : null)];

        if (widget.type === WidgetType.GOAL && widget.metadata.dynamic.predefined_data) {
            isotopeClassList.push(WidgetGoalModelFactory.getGoalWidget(widget.metadata.dynamic.predefined_data.data[0]).getIsotopeClass());
        }

        return isotopeClassList.join(' ');
    }

    function toggleResizeGrid() {
        return vm.resizingWidget && WidgetResizeService.getIsActive();
    }

    /**
     * Receive reactive state changes from WidgetResizeService
     * @param active
     * @private
     */
    function _onWidgetResize(active) {
        if (!active && vm.resizingWidget) { // went resizing to not resizing
            vm.resizingWidget = null;
        }
    }

    /**
     * @param widget
     * @private
     */
    function _updateBuilderWidget(widget) {
        LayoutFactory.updateWidget(widget);
    }

    /**
     * @param widget
     * @private
     */
    function _addBuilderWidget(widget) {
        LayoutFactory.addWidget(widget);
    }

    /**
     * @param params
     * @private
     */
    function _swapBuilderWidget(params) {
        LayoutFactory.swapWidget(params.id, params.model);
    }

    /**
     * @param widgetId
     * @private
     */
    function _removeBuilderWidget(widgetId) {
        LayoutFactory.removeWidgetById(widgetId);
    }

    function _sendDataToAI({ agent }) {
      if(Permission.hasPermissionToRead(Module.DASHBOARDCHATGPTSUMMARIES) || Permission.hasPermissionToRead(Module.REPORTSTUDIOCHATGPTSUMMARIES)) {
        const currentLayout = DesignFactory.getCurrentLayout();
        let range = AppFactory.getCurrentRelativeDateRange();
        const comparisonConfig = AppFactory.getComparisonDateRange();
        if(range === RelativeDateRange.CUSTOM) {
          range = AppFactory.getDateRange();
          range.start = moment.unix(range.start).utc();
          range.end = moment.unix(range.end).utc();
        } else {
          range = DateRangeFactory.getDateRangeFromRelativeRange(range);
        }

        let startDate = range.start.format(MomentDateFormat.ISO);
        let endDate = range.end.format(MomentDateFormat.ISO);
        let dateRange = `${startDate}|${endDate}`;
        let dateRangeDisplay = range.formatted
            ? `${range.formatted.start} to ${range.formatted.end}`
            : `${startDate} to ${endDate}`;

        if (comparisonConfig.enabled) {
            dateRange += `,${moment.unix(comparisonConfig.start).utc().format(MomentDateFormat.ISO)}|${moment
                  .unix(comparisonConfig.end)
                  .utc()
                  .format(MomentDateFormat.ISO)}`;
            dateRangeDisplay += ` Compared to ${comparisonConfig.formatted.start} to ${comparisonConfig.formatted.end}`;
        }
        const showAddSummaryPanel = _.isNil(agent.showAddSummaryPanel) || agent.showAddSummaryPanel;

        const configs = {
          // eslint-disable-next-line tap/no-raw-text-js
          type: "section",
          dateRange: dateRange,
          dateRangeDisplay: dateRangeDisplay,
          pageId: DesignFactory.getCurrentPage().id,
          sectionTitle: currentLayout.title,
          pageTitle: DesignFactory.getCurrentPage().title,
          prompt: agent.prompt,
          metadata: agent.id ? { agent_id: agent.id } : { prompt: agent.prompt },
          sectionId: currentLayout.id,
          showAddSummaryPanel,
        };

        EventBus.signal(AI_CONFIGS_READY_EVENT, { agent, configs });

      } else {
        const options = {};
        options.text = gettextCatalog.getString('You do not have permission to view this insight. Please contact your Instance Admin and request permission to access');
        UIFactory.warn(options);
      }
    }

    /**
     * @private
     */
    function _registerEvents() {
        PubSub.on($WidgetBuilderEvents.UPDATE_WIDGET, _updateBuilderWidget);
        PubSub.on($WidgetBuilderEvents.DID_SAVE_WIDGET, _updateBuilderWidget);
        PubSub.on($WidgetBuilderEvents.ADD_WIDGET, _addBuilderWidget);
        PubSub.on($WidgetBuilderEvents.SWAP_WIDGET, _swapBuilderWidget);
        PubSub.on($WidgetBuilderEvents.REMOVE_WIDGET, _removeBuilderWidget);
        EventBus.listen(AI_ASSISTANT_CLICK_EVENT, _sendDataToAI);
    }

    /**
     * @private
     */
    function _unregisterEvents() {
        PubSub.off($WidgetBuilderEvents.UPDATE_WIDGET, _updateBuilderWidget);
        PubSub.off($WidgetBuilderEvents.DID_SAVE_WIDGET, _updateBuilderWidget);
        PubSub.off($WidgetBuilderEvents.ADD_WIDGET, _addBuilderWidget);
        PubSub.off($WidgetBuilderEvents.SWAP_WIDGET, _swapBuilderWidget);
        PubSub.off($WidgetBuilderEvents.REMOVE_WIDGET, _removeBuilderWidget);
        EventBus.destroy(AI_ASSISTANT_CLICK_EVENT);
        EventBus.destroy(AI_CONFIGS_READY_EVENT);
    }
}

/**
 * @ngInject
 */
function resetDelayedAnimation(
    $timeout,
    PubSub,
    $LayoutEvents
) {
    return {
        restrict: 'A',
        scope: false,
        link: ($scope, $el) => {
            if ($($el).has('.layout-freeflow').length) {
                return;
            }
            $scope.$on('$destroy', function () {
                PubSub.off($LayoutEvents.IS_CHANGING_LAYOUT, layoutChanged);
                PubSub.off($LayoutEvents.CHANGED, layoutChanged);
            });

            let timeoutPromise = null;

            reset();

            PubSub.on($LayoutEvents.IS_CHANGING_LAYOUT, layoutChanged);
            PubSub.on($LayoutEvents.CHANGED, layoutChanged);

            function layoutChanged() {
                $el.css('animation-fill-mode', ''); // remove inline style
                $el.css('transform', ''); // remove inline style
                $el.css('opacity', 0);
                reset();
            }

            /**
             * Stops execution of the requested timeout function
             */
            function cancel() {
                $timeout.cancel(timeoutPromise);
            }

            /**
             * Re-triggers reset css
             */
            function reset() {
                cancel();
                timeoutPromise = $timeout(() => {
                    $el.css('opacity', 1);
                    $el.css('animation-fill-mode', 'initial');
                    $el.css('transform', 'initial');
                }, 1000, false);
            }
        }
    }
}